import 'css-chunksrc/client/pages/planzoneLogsPage/logs/log/styles.scss';export default {
  "log": "_log_19y2b_1",
  "body": "_body_19y2b_11",
  "author": "_author_19y2b_19",
  "infoBubble": "_infoBubble_19y2b_27",
  "slideIn": "_slideIn_19y2b_1",
  "avatar": "_avatar_19y2b_33",
  "creationDate": "_creationDate_19y2b_38"
};